export function isValidDate(date: string): boolean {
  /* Returns false if date is not a valid date representation */
  return !isNaN(new Date(date).getTime());
}

export const secondToTime = (second: number): string => {
  const secNum = second; // don't forget the second param
  let hours: number | string = Math.floor(secNum / 3600);
  let minutes: number | string = Math.floor((secNum - hours * 3600) / 60);
  let seconds: number | string = secNum - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = '0' + hours;
  }

  if (minutes < 10) {
    minutes = '0' + minutes;
  }

  if (seconds < 10) {
    seconds = '0' + seconds;
  }

  return ' ' + hours + ':' + minutes + ':' + seconds;
};

export const getDurationText = (
  duration?: number | null,
  noMinutesAt?: number,
  noSeconds?: boolean
): string => {
  if (duration === null || duration === undefined) {
    return '...';
  }
  if (!duration) {
    return noSeconds ? '0m' : '0s';
  }
  if (duration < 60) {
    noSeconds = false;
  }
  const hours = Math.floor(duration / 3600);
  const mins = Math.floor((duration % 3600) / 60);
  const secs = Math.floor(duration % 60);

  return [
    hours > 0 && `${hours.toLocaleString()}h`.padStart(2, '0'),
    mins > 0 && hours < (noMinutesAt ?? 999999999) && `${mins}m`.padStart(2, '0'),
    noSeconds ? '' : secs > 0 && `${secs}s`.padStart(2, '0'),
  ]
    .filter(Boolean)
    .join(' ');
};
